import * as axios from 'axios';
import httpClient from './httpClient';
import {
    orderList,
    objectifyArr
} from './helper';

var endPoints = ["Cities", "GroundResults", "RegulatoryIndex"];

const getTable = async function () {

    let endPointsArr = [];
    let results = [];

    endPointsArr = endPoints.map(function (item) {
        return httpClient.get(process.env.VUE_APP_BASE_URL + item);
    });

    await Promise.all(endPointsArr)
        .then(res => {
            results = [objectifyArr(res[0].data.records), orderList(res[1].data.records), objectifyArr(res[2].data.records)];
        })
        .catch((err) => {
            console.log(err);
        });
    return results ;
};

export const cases = {
    getTable,
};